import { FC } from 'react';

export const ContentWrapper: FC = ({ children }) => {
  return <main className="layout-container">{children}</main>;
};
